module.exports = "/static/assets/4b9e70e5ad6ef623649d528723adb033.png";